import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { FormControlComponent, getFormControlProviders } from '@app/shared/abstracts/form-control.component';

// 10-20 characters, at least one uppercase letter, one lowercase letter and one number:
const MIN_LENGTH = 10;
const MAX_LENGTH = 20;
const VALIDATION_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\w\S]{10,20}$/;

@Component({
  selector: 'tc-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: getFormControlProviders(PasswordFieldComponent),
})
export class PasswordFieldComponent extends FormControlComponent {
  @Input()
  autofocus = false;

  public control = new UntypedFormControl(
    '',
    Validators.compose([
      Validators.required,
      Validators.minLength(MIN_LENGTH),
      Validators.maxLength(MAX_LENGTH),
      Validators.pattern(VALIDATION_PATTERN),
    ]),
  );

  private obfuscated = true;

  public get type(): string {
    return this.obfuscated ? 'password' : 'text';
  }

  public get icon(): string {
    return this.obfuscated ? 'visibility_off' : 'visibility';
  }

  public get length(): number {
    return this.control.value.length;
  }

  public get minLength(): number {
    return MIN_LENGTH;
  }

  public get maxLength(): number {
    return MAX_LENGTH;
  }

  public get error(): string | null {
    return this.control.errors && Object.keys(this.control.errors)[0];
  }

  public toggleObfuscated(): void {
    this.obfuscated = !this.obfuscated;
  }
}
